<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'TIPORESPALDO.LBL_TIPORES' | translate }}">

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>{{ 'LBL_CODIGO' | translate }}:</label>
          <label class="falso-combo-texto">{{tipoRespaldo.codigo}}</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>{{ 'LBL_NOMBRE' | translate }}:</label>
          <label class="falso-combo-texto">{{tipoRespaldo.nombre}}</label>
        </div>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-12 lg:col-12">
        <div class="div-form">
          <label>{{ 'TIPORESPALDO.LBL_DESTIPRES' | translate }}:</label>
          <label class="falso-combo-texto">{{tipoRespaldo.descripcion}}</label>
        </div>
      </div>
    </div>

    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4 ">
        <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                    id="indicadorHabilitado"
                    name="nomIndicadorHabilitado"
                    [ngModel]="tipoRespaldo.indicadorHabilitado"
                    [disabled]="true"></p-checkbox>
      </div>
    </div>

  </p-panel>
  <p-panel header="{{ 'TIPORESPALDO.LBL_AGRCATEGORIA' | translate }}">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carTabla" #dt
                 [value]="lisTipoRespaldoCategoria" selectionMode="single" dataKey="nombre"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombre}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>
<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
            pButton (click)="regresar(false)"></button>
  </div>
</div>
